module.exports = __webpack_public_path__ + "static/img/userLogin.e6064f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/userLogin.png
// module id = dc6Z
// module chunks = 0